import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { HashLocationStrategy,LocationStrategy, PathLocationStrategy } from '@angular/common';
// import {ɵROUTER_PROVIDERS} from '@angular/router';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { TopnavComponent } from './topnav/topnav.component';
import { DashboardComponent } from './tabs/dashboard/dashboard.component';

import { Globals } from './globals';
import { NgSelectModule } from '@ng-select/ng-select';
import { PendingrequestComponent } from './tabs/pending/pendingrequest/pendingrequest.component';
import { PendingViewMobileComponent } from './tabs/pending/pending-view-mobile/pending-view-mobile.component';
import { ApprovedHcComponent } from './tabs/approved/approved-hc/approved-hc.component';
import { ApprovedViewMobileComponent } from './tabs/approved/approved-view-mobile/approved-view-mobile.component';
import { StaredViewMobileComponent } from './tabs/stared/stared-view-mobile/stared-view-mobile.component';
import { StaredHcComponent } from './tabs/stared/stared-hc/stared-hc.component';
import { ShowhiddenHcComponent } from './tabs/showhidden/showhidden-hc/showhidden-hc.component';
import { ShowhiddenViewMobileComponent } from './tabs/showhidden/showhidden-view-mobile/showhidden-view-mobile.component';
import { TrashHcComponent } from './tabs/trash/trash-hc/trash-hc.component';
import { TrashViewMobileComponent } from './tabs/trash/trash-view-mobile/trash-view-mobile.component';
import { SpecificationComponent } from './tabs/specification/specification/specification.component';
import { SpecificationHcComponent } from './tabs/specification/specification-hc/specification-hc.component';
import { SpecificationViewMobileComponent } from './tabs/specification/specification-view-mobile/specification-view-mobile.component';
import { RemarkComponent } from './tabs/remark/remark/remark.component';
import { RemarkHcComponent } from './tabs/remark/remark-hc/remark-hc.component';
import { RemarkViewMobileComponent } from './tabs/remark/remark-view-mobile/remark-view-mobile.component';
import { SubjectComponent } from './tabs/subject/subject/subject.component';
import { SubjectHcComponent } from './tabs/subject/subject-hc/subject-hc.component';
import { SubjectViewMobileComponent } from './tabs/subject/subject-view-mobile/subject-view-mobile.component';
import { UpdateHcComponent } from './tabs/update-hc/update-hc.component';
import { VitalComponent } from './tabs/vital/vital/vital.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GetotpallapprovedComponent } from './tabs/allapproved/getotpallapproved/getotpallapproved.component';
import { VitalchartComponent } from './tabs/vital/vitalchart/vitalchart.component';
import { DemoMaterialModule} from './material-modules';
import { MatNativeDateModule} from '@angular/material';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { BlankpageComponent } from './blankpage/blankpage.component';
// import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { PaymentfailureComponent } from './paymentfailure/paymentfailure.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { SafeHtmlPipe } from './service/pipe/safepipe';
import { AddTransctionPasswordComponent } from './add-transction-password/add-transction-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

import { DataService } from './service/apiservice/data.service';

// import { ImageViewerModule } from 'ngx-image-viewer';
import {NgxDocViewerModule} from 'ngx-doc-viewer';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { ProfileComponent } from './profile/profile.component';
import { UpdateprofileComponent } from './updateprofile/updateprofile.component';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharehealthcardComponent } from './sharehealthcard/sharehealthcard.component';
import { DoctordashbordComponent } from './doctordashbord/doctordashbord/doctordashbord.component';
import { DoctorpageComponent } from './doctordashbord/doctorpage/doctorpage.component';
import { DoctorsidenavComponent } from './doctorsidenav/doctorsidenav.component';
import { ɵROUTER_PROVIDERS } from '@angular/router';
import { SendemailComponent } from './tabs/sendemail/sendemail/sendemail.component';
import { NgxSpinnerModule } from "ngx-spinner";
import {WebcamModule} from 'ngx-webcam';
// import {NgxPrintModule} from 'ngx-print';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SendemailViewMobileComponent } from './tabs/sendemail/sendemail-view-mobile/sendemail-view-mobile.component';
import { AllapprovedViewMobileComponent } from './tabs/allapproved/allapproved-view-mobile/allapproved-view-mobile.component';
// import {MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
// import { HintModule, HintService } from 'angular-custom-tour';
// import { TourMatMenuModule } from 'ngx-tour-md-menu';
// import { TourService } from 'ngx-tour-core';
import { CampregistrationComponent } from './doctordashbord/campregistration/campregistration.component';
import { HealthCardBackSideComponent } from './doctordashbord/health-card-back-side/health-card-back-side.component';
import { UpdateCampRegisterUserComponent } from './doctordashbord/update-camp-register-user/update-camp-register-user.component';
import { MultiUserRegistrationComponent } from './doctordashbord/multi-user-registration/multi-user-registration.component';
import { CKEditorModule } from 'ng2-ckeditor';

// firebase
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './messaging.service';
import { environment } from '../environments/environment';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { BuyNowButtonClickComponent } from './buy-now-button-click/buy-now-button-click.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SidenavComponent,
    TopnavComponent,
    DashboardComponent,
   
    PendingrequestComponent,
    PendingViewMobileComponent,
    ApprovedHcComponent,
    ApprovedViewMobileComponent,
    StaredHcComponent,
    StaredViewMobileComponent,
    ShowhiddenHcComponent,
    ShowhiddenViewMobileComponent,
    TrashHcComponent,
    TrashViewMobileComponent,
    SpecificationComponent,
    SpecificationHcComponent,
    SpecificationViewMobileComponent,
    RemarkComponent,
    RemarkHcComponent,
    RemarkViewMobileComponent,
    SubjectComponent,
    SubjectHcComponent,
    SubjectViewMobileComponent,
    UpdateHcComponent,
    VitalComponent,
    GetotpallapprovedComponent,
    VitalchartComponent,
   
    BlankpageComponent,
    PaymentfailureComponent,
    PaymentsuccessComponent,
 SafeHtmlPipe,
 AddTransctionPasswordComponent,
 ChangePasswordComponent,
 
 ProfileComponent,
 UpdateprofileComponent,
 SharehealthcardComponent,
 DoctordashbordComponent,
 DoctorpageComponent,
 DoctorsidenavComponent,
 SendemailComponent,
 SendemailViewMobileComponent,
 AllapprovedViewMobileComponent,
 CampregistrationComponent,
 HealthCardBackSideComponent,
 UpdateCampRegisterUserComponent,
 MultiUserRegistrationComponent,
 BuyNowButtonClickComponent

  ],
  imports: [
    DemoMaterialModule,
    MatNativeDateModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgbModule,
    // InternationalPhoneNumberModule,
    PdfViewerModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgxSpinnerModule,
    NgxDocViewerModule,
    ImageViewerModule,
    ShareButtonsModule.withConfig({
      debug: true
    }),
    WebcamModule,
    // NgxPrintModule,
    AngularMultiSelectModule,
    // MultiSelectAllModule
    // HintModule,
    // TourMatMenuModule.forRoot(),
    CKEditorModule,
    AngularFireDatabaseModule,
      AngularFireAuthModule,
      AngularFireMessagingModule,
      AngularFireModule.initializeApp(environment.firebase),
   
  ],
  // TourService,HintService,
  providers: [MessagingService,AsyncPipe,Globals,DatePipe,DataService,CookieService, [ ɵROUTER_PROVIDERS,
    {provide: LocationStrategy, useClass: HashLocationStrategy}]],//,ɵROUTER_PROVIDERS,{provide:LocationStrategy,useClass:HashLocationStrategy}   
  bootstrap: [AppComponent]
})
export class AppModule { }


